import { Column } from 'react-table'
import { columnGenerators } from '../../../../../../_metronic/helpers'

export const header = (isSupplyChainManager = false) => [
  {
    label: 'S.N',
    value: 'S.N',
  },
  {
    label: 'Date',
    value: 'actualCollectionDateMI',
  },
  // {
  //   label: 'Type',
  //   value: 'wasteSource',
  // },
  {
    label: 'Batch id',
    value: 'id',
  },
  {
    label: 'Facility',
    value: 'centreInfo[name]',
  },
  // {
  //   label: isSupplyChainManager ? 'Supply chain' : 'Franchisee',
  //   value: 'franchiseName',
  // },
  {
    label: 'Category',
    value: 'categoryName',
  },
  {
    label: 'Item',
    value: 'remark',
  },
  {
    label: 'Quantity (KG)',
    value: 'quantityDeposit_remark',
  },
  // {
  //   label: 'Price',
  //   // value: 'price',
  //   value: 'totalAmountI',
  // },
  {
    label: 'Supplier',
    value: 'B2B1',
  },
  {
    label: 'Site',
    value: 'mapLocation',
  },
  {
    label: 'Status',
    value: 'status',
  },
  // {
  //   label: 'Contact',
  //   value: 'customerInfo[mobile]',
  // },
  {
    action: ['edit', 'view', /* 'id', */ 'qr'],
  },
]

const roleColumns = (isSupplyChainManager = false) => {
  return columnGenerators(header(isSupplyChainManager))
}
export { roleColumns }
